import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import {
  Typography,
  Button,
  Box,
  Paper,
  Grid,
  TextField,
  CircularProgress,
  Snackbar,
  IconButton,
} from '@material-ui/core';
import { Save as SaveIcon, Close as CloseIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useForm } from '@omega-energia/react';
import { usePermissions } from '../../../../hooks/usePermissions/usePermissions';
import { useAuth } from '../../../../auth/authProvider';
import styles from '../Credito.style';
import req from '../../../../services/network/request';
import { MWMFormatCustom } from '../../../../components/MWMFormatCustom/MWMFormatCustom';
import { NumberFormatCustom } from '../../../../components/NumberFormatCustom/NumberFormatCustom';

const useStyles = makeStyles(styles);

function ValorLimiteContratacao(props) {
  const classes = useStyles(props);
  const { token } = useAuth();
  const [ready, setReady] = useState(false);
  const [canSave, setCanSave] = useState(false);
  const [alert, setAlert] = useState({ show: false, msg: '', type: '' });

  const { getPermissions } = usePermissions();
  const editar = getPermissions();

  const [saveLimiteValorLimiteContratacao] = useMutation(
    postData => req.put('/valor-limite-contratacao-gd', postData, { token }),
    {
      onError: error => {
        setAlert({ show: true, msg: error.message, type: 'error' });
      },
      onSuccess: () => {
        setCanSave(false);
        setAlert({
          show: true,
          msg: 'Os parâmetros de valor limite de contratação GD foram alterados.',
          type: 'success',
        });
        setTimeout(() => {
          setAlert({ ...alert, show: false });
        }, 3000);
      },
    },
  );

  const fields = {
    valorLimiteScoreMinimo: '',
    valorLimiteConsumoMaximo: '',
  };

  const handleScoreLimite = score => (score > 1000 ? 1000 : score);

  const [inputs, handleChange, handleSubmit, , setInputs] = useForm(fields, payload => {
    const dataPayload = {
      id: inputs.id,
      valorLimiteConsumoMaximo: parseFloat(payload.valorLimiteConsumoMaximo.replace(',', '.')),
      valorLimiteScoreMinimo: handleScoreLimite(payload.valorLimiteScoreMinimo),
    };

    saveLimiteValorLimiteContratacao(dataPayload);
  });

  useQuery('fetch-valor-limite-contratacao-gd', () => req.get('/valor-limite-contratacao-gd', { token }), {
    onSuccess: successData => {
      if (successData && successData?.valorLimiteConsumoMaximo) {
        successData.valorLimiteConsumoMaximo = successData.valorLimiteConsumoMaximo.replace('.', ',');
        setInputs(successData);
      }
      setReady(true);
    },
  });

  const closeSnackBarIcon = (
    <IconButton size="small" aria-label="close" color="inherit" onClick={() => setAlert({ ...alert, show: false })}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <form
      onChange={e => {
        setCanSave(true);
        handleChange(e);
      }}
      onSubmit={handleSubmit}
    >
      {ready ? (
        <Paper className={classes.paper}>
          <Box display="flex" flexDirection="row" justifyContent="space-between" pb={4}>
            <Box>
              <Typography variant="h5">Crédito automático - GD</Typography>
            </Box>
            <Box>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                align="right"
                disabled={!inputs.valorLimiteScoreMinimo || !inputs.valorLimiteConsumoMaximo || !canSave || !editar}
              >
                <SaveIcon /> SALVAR
              </Button>
            </Box>
          </Box>

          <Grid container spacing={4}>
            <Grid item xs={12}>
              <TextField
                value={handleScoreLimite(inputs.valorLimiteScoreMinimo)}
                name="valorLimiteScoreMinimo"
                label="Score mínimo para contratação GD"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: !!inputs.valorLimiteScoreMinimo || inputs.valorLimiteScoreMinimo === 0,
                }}
                required
                disabled={!editar}
                InputProps={{
                  inputComponent: NumberFormatCustom,
                }}
              />
              {process.env.REACT_APP_AMBIENTE !== 'production' && (
                <Typography variant="caption">
                  Empresas em {process.env.REACT_APP_AMBIENTE} sempre terão 400pts
                </Typography>
              )}
            </Grid>

            <Grid item xs={12}>
              <TextField
                value={inputs.valorLimiteConsumoMaximo}
                name="valorLimiteConsumoMaximo"
                label="Consumo (MWm)"
                variant="outlined"
                fullWidth
                required
                disabled={!editar}
                InputProps={{
                  inputComponent: MWMFormatCustom,
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      ) : (
        <div className={classes.progressWrapper} align="center">
          <CircularProgress />
        </div>
      )}
      <Snackbar
        variant={alert.type}
        open={alert.show}
        autoHideDuration={3000}
        message={<span>{alert.msg}</span>}
        action={closeSnackBarIcon}
      />
    </form>
  );
}

export default ValorLimiteContratacao;
